import React, { useCallback, useState, useContext, createContext, useRef, useEffect } from 'react';

const defaultValue = {};

export const AlertContext = createContext(defaultValue);

export const AlertContextProvider = (props) => {
  const [state, setState] = useState(defaultValue);
  const timerRef = useRef(null);

  const handleAlertSetState = useCallback((newState) => {
    const { title, description, variant, autoHideDuration, actionText, actionProps } = newState;
    setState({
      title,
      description,
      variant: variant ?? 'bambuserSuccess',
      isOpen: Boolean(title),
      autoHideDuration: autoHideDuration ?? 5000,
      actionText,
      actionProps,
    });
  }, []);

  useEffect(() => {
    const onClose = () => {
      handleAlertSetState({});
    };

    if (!state.isOpen) return;
    timerRef.current = setTimeout(onClose, state.autoHideDuration);
    return () => clearTimeout(timerRef.current);
  }, [handleAlertSetState, state.autoHideDuration, state.isOpen]);

  const context = {
    ...state,
    setAlert: handleAlertSetState,
  };

  return <AlertContext.Provider value={context}>{props.children}</AlertContext.Provider>;
};

export const useAlert = () => useContext(AlertContext);
